import {
  SuccessPlanAction,
  SuccessPlanState,
} from "components/summary/success-plan/state/successPlan.types";

export const initialState: SuccessPlanState = {
  mode: "view",
  status: "idle",
  stepIndicator: null,
  account: null,
  selectedAccounts: [],
  spData: null,
};

export function successPlanReducer(
  state: SuccessPlanState,
  action: SuccessPlanAction
): SuccessPlanState {
  switch (action.type) {
    case "hydrate":
      return {
        ...state,
        status: "ready",
        account: action.payload.account,
        selectedAccounts: action.payload.selectedAccounts,
        spData: action.payload.spData || null,
        stepIndicator: action.payload.stepIndicator || null,
      };
    case "successplan/refresh":
      return {
        ...state,
        spData: action.payload,
      };
    case "request/pending":
      return {
        ...state,
        status: "loading",
      };
    case "request/failure":
      return {
        ...state,
        status: "error",
      };
    case "request/success":
      return {
        ...state,
        status: "ready",
      };
    case "setMode":
      return {
        ...state,
        mode: action.payload,
      };
    case "setStepIndicator":
      return {
        ...state,
        stepIndicator: action.payload,
      };
    default:
      return state;
  }
}
